import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { PersonAvatar } from './PeopleUI';

export default function CommentMentionInput({ inputRef, value, onChange, onMention, onSubmit, disabled, style }) {
  const [match, setMatch] = useState(null);
  const [people, setPeople] = useState([]);
  const [status, setStatus] = useState('');
  const [active, setActive] = useState(0);
  const version = useRef(0);
  const inspect = input => {
    const end = input.selectionStart ?? input.value.length;
    const found = input.value.slice(0, end).match(/(?:^|\s)([@＠])([^@＠\s]*)$/u);
    setMatch(found ? { start: end - found[2].length - 1, end, query: found[2] } : null);
  };
  useEffect(() => {
    const current = ++version.current;
    setPeople([]); setActive(0);
    if (!match) return;
    setStatus('検索中…');
    const controller = new AbortController();
    const timer = setTimeout(() => {
      axios.get('/api/users', { params: { q: match.query }, signal: controller.signal }).then(({ data }) => {
        if (current !== version.current) return;
        const results = data.slice(0, 6); setPeople(results); setStatus(results.length ? '' : 'ユーザーが見つかりません');
      }).catch(() => { if (!controller.signal.aborted && current === version.current) setStatus('検索できませんでした'); });
    }, 180);
    return () => { clearTimeout(timer); controller.abort(); };
  }, [match]);
  const choose = person => {
    const inserted = `@${person.username} `;
    const next = value.slice(0, match.start) + inserted + value.slice(match.end);
    if (next.length > 400) { setStatus('コメントは400文字以内で入力してください'); return; }
    const cursor = match.start + inserted.length;
    onChange(next); onMention(person); setMatch(null);
    requestAnimationFrame(() => { inputRef.current?.focus(); inputRef.current?.setSelectionRange(cursor, cursor); });
  };
  return <div className="jt-mention-input-wrap">
    {match && <div className="jt-mention-options" aria-label="メンション候補">
      {status && <p role="status">{status}</p>}
      {people.map((person, index) => <button type="button" key={person.id} className={index === active ? 'is-active' : ''} aria-label={`${person.username}をメンション`} onMouseDown={event => event.preventDefault()} onClick={() => choose(person)}><PersonAvatar person={person} size={30} /><span>{person.username}</span></button>)}
    </div>}
    <input ref={inputRef} value={value} disabled={disabled} style={style} data-post-part="commentInput" aria-label="コメント内容" placeholder="コメントを追加… @でメンション" maxLength={400}
      onChange={event => { onChange(event.target.value); inspect(event.target); }} onClick={event => inspect(event.target)}
      onKeyDown={event => {
        if (event.nativeEvent.isComposing) return;
        if (match && event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); setMatch(null); return; }
        if (match && people.length && ['ArrowDown', 'ArrowUp'].includes(event.key)) { event.preventDefault(); setActive(i => (i + (event.key === 'ArrowDown' ? 1 : people.length - 1)) % people.length); return; }
        if (event.key === 'Enter') { event.preventDefault(); if (match) { if (people[active]) choose(people[active]); } else if (value.trim()) onSubmit(); }
      }} />
  </div>;
}
